import { batchesAPI } from '../services/api';
import { canCreateEnrollmentBatch } from '../domain/adminUser/enrollmentRequirement';

/**
 * Resolve batchId for the current enroll combo: reuse an existing batch or create one.
 */
export async function ensureEnrollmentBatchFromForm(formData) {
  if (!canCreateEnrollmentBatch(formData)) {
    const err = new Error('Select course, mode, and batch start date');
    err.statusCode = 400;
    throw err;
  }
  if (String(formData.modeOfCourse).trim() === 'Offline' && !String(formData.locationOfCenter || '').trim()) {
    const err = new Error('Select a center for Offline');
    err.statusCode = 400;
    throw err;
  }
  const res = await batchesAPI.ensure({
    courseId: formData.courseId,
    mode: formData.modeOfCourse,
    location: formData.locationOfCenter || '',
    startDate: formData.batchStartDate,
    expectedCompletionDate: formData.courseCompletionDate || '',
  });
  return res.data;
}
